        <div class="row row-cols-1 row-cols-lg-3 g-4">

            <div class="col col-12 col-lg-3 col-xl-2">
                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-between">
                        <h4 class="card-title"><i class="fa fa-fw fa-clipboard-check"></i>My Audits</h4>
                        <a href="#" class="float-end text-primary" data-bs-toggle="collapse" data-bs-target="#collapseCard1">
                            <i class="fa fa-chevron-down"></i>
                        </a>
                    </div>
                    <!-- Card body with a unique id and collapse class -->
                    <div id="collapseCard1" class="collapse show">
                        <div class="card-body">
                            <h6 class="card-subtitle text-danger"><i class="fa fa-fw fa-exclamation-triangle me-1"></i>Overdue Audits</h6>
                            <div class="mb-3">
                                <div class="d-flex pb-1 mb-1 border-bottom" *ngFor="let a of overdueAudits">
                                    <div class="flex-grow-1">
                                        <span class="text-danger">{{a.title}}</span>
                                    </div>
                                    <div class="d-flex align-items-end ms-2">
                                        <span class="text-danger">{{a.deadlineDate | date:'dd/MM/yyyy'}}</span>
                                    </div>
                                </div>

                            </div>

                            <h6 class="text-muted card-subtitle mb-2"><i class="fa fa-fw fa-clock me-1"></i>Upcoming Audits</h6>
                            <div class="mb-3">
                                <div class="d-flex pb-1 mb-1 border-bottom" *ngFor="let a of upcomingAudits">
                                    <div class="flex-grow-1">
                                        {{a.title}}
                                    </div>
                                    <div class="d-flex align-items-end ms-2">
                                        {{a.deadlineDate | date:'dd/MM/yyyy'}}
                                    </div>
                                </div>
                                <div class="d-flex pb-1 mb-1" *ngIf="upcomingAudits?.length==0">
                                    <div class="flex-grow-1">
                                        <span class="text-primary">No Audits due in the next month</span>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="managerNonACRCompanyUserList?.length > 0 || isAdmin">
                    <div class="card-header d-flex align-items-center justify-content-between">
                        <h4 class="card-title"><i class="fa fa-fw fa-bullseye"></i>Audit Targets</h4>
                        <a href="#" class="float-end text-primary" data-bs-toggle="collapse" data-bs-target="#collapseCard2">
                            <i class="fa fa-chevron-down"></i>
                        </a>
                    </div>
                    <!-- Card body with a unique id and collapse class -->
                    <div id="collapseCard2" class="collapse show" *ngIf="managerNonACRCompanyUserList?.length>0||isAdmin">
                        <div class="card-body">
                            <div *ngFor="let x of auditReportPeriods">
                            <h6 class="text-muted card-subtitle mb-2">{{x.companyName}}</h6>
                            <div class="table-responsive">
                                <div class="d-flex pb-1 mb-1 border-bottom">
                                    <div class="flex-grow-1">{{x.p0_Label}}</div>
                                    <div class="d-flex align-items-end ms-22" *ngIf="x.p0_Audits > 0">{{x.p0_Audits}}</div>
                                    <div class="d-flex align-items-end ms-22 text-danger" *ngIf="x.p0_Audits == 0">{{x.p0_Audits}}</div>
                                </div>
                                <div class="d-flex pb-1 mb-1 border-bottom">
                                    <div class="flex-grow-1">{{x.p1_Label}}</div>
                                    <div class="d-flex align-items-end ms-22" *ngIf="x.p1_Audits > 0">{{x.p1_Audits}}</div>
                                    <div class="d-flex align-items-end ms-22 text-danger" *ngIf="x.p1_Audits == 0">{{x.p1_Audits}}</div>
                                </div>
                                <div class="d-flex pb-1 mb-1 border-bottom">
                                    <div class="flex-grow-1">{{x.p2_Label}}</div>
                                    <div class="d-flex align-items-end ms-22" *ngIf="x.p2_Audits > 0">{{x.p2_Audits}}</div>
                                    <div class="d-flex align-items-end ms-22 text-danger" *ngIf="x.p2_Audits == 0">{{x.p2_Audits}}</div>
                                </div>
                                <div class="d-flex pb-1 mb-1 border-bottom">
                                    <div class="flex-grow-1">{{x.p3_Label}}</div>
                                    <div class="d-flex align-items-end ms-22" *ngIf="x.p3_Audits > 0">{{x.p3_Audits}}</div>
                                    <div class="d-flex align-items-end ms-22 text-danger" *ngIf="x.p3_Audits == 0">{{x.p3_Audits}}</div>
                                </div>
                            </div>
                            <p class="text-primary mt-2">Reporting period is {{x.period}}ly</p>
                        </div></div>
                    </div>
                </div>

                <div class="card" *ngIf="managerNonACRCompanyUserList?.length > 0 || isAdmin">
                    <ng-container *ngFor="let c of managerNonACRCompanyUserList">
                        <div class="card-header d-flex align-items-center justify-content-between">
                            <h4 class="card-title"><i class="fas fa-flag-checkered"></i>Milestones</h4>
                            <hr class="my-2" />
                            <a href="#" class="float-end text-primary" data-bs-toggle="collapse" data-bs-target="#collapseCard3">
                                <i class="fa fa-chevron-down"></i>
                            </a>
                        </div>
                        <!-- Card body with a unique id and collapse class -->
                        <div id="collapseCard3" class="collapse show" *ngIf="managerNonACRCompanyUserList?.length > 0 || isAdmin">
                            <div class="card-body">
                                <h6 class="text-muted card-subtitle mb-2" *ngIf="managerNonACRCompanyUserList?.length > 0"> {{c.companyName}}</h6>
                                <div class="row mb-2">
                                    <div class="col-10 small text-muted">
                                        PI Insurance renewal
                                    </div>
                                    <div class="col-2">
                                        <i class="fas fa-exclamation-circle text-danger" *ngIf="c.piExpiry < (today | date:'y-MM-ddT00:00:00')"></i>
                                        <i class="fas fa-exclamation-triangle text-warning" *ngIf="c.piExpiry > (today | date:'y-MM-ddT00:00:00') && c.piExpiry < (oneMonth | date:'y-MM-ddT00:00:00')"></i>
                                        <i class="fas fa-check-circle text-success" *ngIf="c.piExpiry > (oneMonth | date:'y-MM-ddT00:00:00')"></i>
                                    </div>
                                    <div class="col-12 text-2 text-end" *ngIf="c.piExpiry != null">
                                        {{c.piExpiry | date:'dd/MM/yyyy'}}
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-10 small text-muted">
                                        AFCA renewal
                                    </div>
                                    <div class="col-2">
                                        <i class="fas fa-exclamation-circle text-danger" *ngIf="c.afcaExpiry < (today | date:'y-MM-ddT00:00:00')"></i>
                                        <i class="fas fa-exclamation-triangle text-warning" *ngIf="c.afcaExpiry > (today | date:'y-MM-ddT00:00:00') && c.afcaExpiry < (oneMonth | date:'y-MM-ddT00:00:00')"></i>
                                        <i class="fas fa-check-circle text-success" *ngIf="c.afcaExpiry > (oneMonth | date:'y-MM-ddT00:00:00')"></i>
                                    </div>
                                    <div class="col-12 text-2 text-end" *ngIf="c.afcaExpiry != null">
                                        {{c.afcaExpiry | date:'dd/MM/yyyy'}}
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-10 small text-muted">
                                        ACL Anniversary
                                    </div>
                                    <div class="col-2">
                                        <i class="fas fa-exclamation-circle text-danger" *ngIf="c.aclExpiry < (today | date:'y-MM-ddT00:00:00')"></i>
                                        <i class="fas fa-exclamation-triangle text-warning" *ngIf="c.aclExpiry > (today | date:'y-MM-ddT00:00:00') && c.aclExpiry < (oneMonth | date:'y-MM-ddT00:00:00')"></i>
                                        <i class="fas fa-check-circle text-success" *ngIf="c.aclExpiry > (oneMonth | date:'y-MM-ddT00:00:00')"></i>
                                    </div>
                                    <div class="col-12 text-2 text-end" *ngIf="c.aclExpiry != null">
                                        {{c.aclExpiry | date:'dd/MM/yyyy'}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="col col-12 col-lg-6 col-xl-8">
                <div class="card mb-4">
                    <div class="card-header">

                        <div class="grid" style="--bs-columns: 12; --bs-gap: 1rem;">
                            <div class="g-col-12 g-col-xl-5 text-center text-xl-start">
                                <h3 class="text-gray-600 mb-0">Responsible Lending</h3>
                            </div>
                            <div class="g-col-12 g-col-xl-7 text-center text-xl-end">
                                <a class="btn btn-primary me-2" [routerLink]="['/company-audit/request-external']" *ngIf="managerCompanyUserList?.length>0||isAdmin">Request External Audit</a>
                                <a class="btn btn-primary-dark" [routerLink]="['/company-audit/add']">Create New Audit</a>
                            </div>
                        </div>

                    </div>
                    <div class="card-body py-3">

                        <div class="grid" style="--bs-columns: 12; --bs-gap: 1rem;">

                            <div class="g-col-12 g-col-xl-3 bg-primary-400 border-primary rounded p-3">
                                <h6 class="text-white card-subtitle mb-2">Filters</h6>
                                <div class="grid" style="--bs-columns: 1; --bs-gap: .35rem;">
                                    <div class="g-col-2 text-start">
                                        <!--Company-->
                                        <div class="not-a-button w-100 text-start" *ngIf="reportSelectorCompanies?.length == 0 && isAdmin">
                                            <i class="fa fa-fw fa-bank me-1"></i>All Companies
                                        </div>
                                        <button href="#" class="filter-button btn btn-primary-dark btn-sm w-100 text-start" data-bs-toggle="modal" data-bs-target="#companyFilterModal" *ngIf="reportSelectorCompanies?.length>1" data-toggle="tooltip" title="{{reportSelectedCompany}}">
                                            <i class="fa fa-fw fa-bank me-1"></i>{{reportSelectedCompany}}
                                        </button>
                                        <div class="not-a-button w-100 text-start" *ngIf="reportSelectorCompanies?.length==1" data-toggle="tooltip" title="{{reportSelectedCompany}}">
                                            <i class="fa fa-fw fa-bank me-1"></i>{{reportSelectedCompany}}
                                        </div>
                                    </div>
                                    <div class="g-col-2 text-center">
                                        <!--User-->
                                        <div class="not-a-button w-100 text-start" *ngIf="reportSelectorUsers?.length == 0 && isAdmin">
                                            <i class="fa fa-fw fa-users me-1"></i>All Users
                                        </div>
                                        <button href="#" class="filter-button btn btn-primary-dark btn-sm w-100 text-start" data-bs-toggle="modal" data-bs-target="#userFilterModal" *ngIf="reportSelectorUsers?.length>1" data-toggle="tooltip" title="{{reportSelectedUser}}">
                                            <i class="fa fa-fw fa-users me-1"></i>{{reportSelectedUser}}
                                        </button>
                                        <div class="not-a-button w-100 text-start" *ngIf="reportSelectorUsers?.length==1" data-toggle="tooltip" title="{{reportSelectedUser}}">
                                            <i class="fa fa-fw fa-users me-1"></i>{{reportSelectedUser}}
                                        </div>
                                    </div>
                                    <div class="g-col-2 text-center">
                                        <!--Dates-->
                                        <button href="#" class="filter-button btn btn-primary-dark btn-sm w-100 text-start" data-bs-toggle="modal" data-bs-target="#dateFilterModal" data-toggle="tooltip" title="{{startDate | date : 'dd/MM/yyyy'}} - {{endDate | date : 'dd/MM/yyyy'}}">
                                            <i class="fa fa-fw fa-calendar me-1"></i>{{startDate | date : "dd/MM/yyyy"}} - {{endDate | date : "dd/MM/yyyy"}}
                                        </button>
                                    </div>
                                    <div class="g-col-2 text-center">
                                        <!--Rating-->
                                        <button href="#" class="filter-button btn btn-primary-dark btn-sm w-100 text-start" data-bs-toggle="modal" data-bs-target="#ratingFilterModal" data-toggle="tooltip" title="{{reportRatingLabel}}">
                                            <i class="fa fa-fw fa-star me-1"></i>{{reportRatingLabel}}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="g-col-12 g-col-xl-9 border rounded">
                                <div class="row">
                                    <div class="col-lg-4 col-md-4">
                                        <app-chart-rating-pc [ratings]="summaryRatingList" *ngIf="showRatingsChart"></app-chart-rating-pc>
                                    </div>
                                    <div class="col-lg-4 col-md-4">
                                        <app-chart-completed-pc [completed]="summaryCompletedList" *ngIf="showCompletedChart"></app-chart-completed-pc>
                                    </div>
                                    <div class="col-lg-4 col-md-4">
                                        <app-chart-days-to-complete [daysToComplete]="summaryDaysToComplete" *ngIf="showCompletedChart"></app-chart-days-to-complete>
                                    </div>
                                </div>
                            </div>

                            <div class="g-col-12 border rounded p-3">
                                <table class="table table-hover mb-0">
                                    <thead>
                                        <tr>
                                            <th *ngIf="reportSelectorCompanies?.length > 1">Company</th>
                                            <th>Name</th>
                                            <th class="d-none d-xl-table-cell">Start Date</th>
                                            <th class="d-none d-xl-table-cell">Deadline</th>
                                            <th class="d-none d-xl-table-cell">Date Completed</th>
                                            <th>User</th>
                                            <th class="text-center">Status</th>
                                            <th class="text-center">Rating</th>
                                            <th class="text-center">External</th>
                                            <th class="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let a of resLendingAudits;index as i">
                                            <td *ngIf="reportSelectorCompanies?.length>1">{{a.companyName}}</td>
                                            <td>{{a.title}}
                                                <pre style="display:none;">{{a | json}}</pre>
                                            </td>
                                            <td class="d-none d-xl-table-cell">{{a.startDate | date:"dd MMM yyyy" }}</td>
                                            <td class="d-none d-xl-table-cell text-danger" [ngClass]="{'text-danger':a.deadlineDate < today && a.auditStatus == 0}">{{a.deadlineDate | date:"dd MMM yyyy"}}</td>
                                            <td class="d-none d-xl-table-cell text-center">{{a.completedDate | date:"dd MMM yyyy"}}</td>
                                            <td>{{a.userName}}</td>
                                            <td class="text-center">
                                                <span class="far fa-circle text-primary" *ngIf="a.auditStatus==0" data-toggle="tooltip" title="Open"></span>
                                                <span class="fas fa-circle text-primary" *ngIf="a.auditStatus==1" data-toggle="tooltip" title="Completed"></span>
                                            </td>
                                            <td class="text-center">
                                                <ng-container *ngIf="a.auditStatus==0">
                                                </ng-container>
                                                <ng-container *ngIf="a.auditStatus==1 && a.rating">
                                                    <span *ngIf="(a.rating / a.modulesCount) <= 0.25"><span class="fas fa-circle text-success"></span></span>
                                                    <span *ngIf="(a.rating / a.modulesCount) > 0.25 && (a.rating / a.modulesCount) <= 0.75"><span class="fas fa-circle text-warning"></span></span>
                                                    <span *ngIf="(a.rating / a.modulesCount) > 0.75"><span class="fas fa-circle text-danger"></span></span>
                                                </ng-container>
                                                <span class="d-none">{{a.rating / a.modulesCount}}</span>
                                            </td>
                                            <td class="text-center">
                                                <ng-container *ngIf="a.isExternal">
                                                    <i class="fas fa-check"></i>
                                                </ng-container>
                                            </td>
                                            <td class="actions text-center">
                                                <a *ngIf="!a.auditStatus==1" [routerLink]="['/company-audit',a.id]" title="Launch"><i class="fas fa-rocket text-primary"></i></a>
                                                <a *ngIf="a.auditStatus==1" [routerLink]="['/company-audit',a.id]" title="View"><i class="fas fa-eye text-primary"></i></a>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                        </div>


                    </div>
                </div>
                <div class="card">
                    <div class="card-header">

                        <div class="grid" style="--bs-columns: 12; --bs-gap: 1rem;">
                            <div class="g-col-12 g-col-xl-6 text-center text-xl-start">
                                <h3 class="text-gray-600 mb-0">General Business Obligations</h3>
                            </div>
                            <div class="g-col-12 g-col-xl-6 text-center text-xl-end">
                                <a href="#" class="btn btn-primary me-2" [routerLink]="['/company-audit/request-external']" *ngIf="managerNonACRCompanyUserList?.length>0||isAdmin">Request External Audit</a>
                                <a href="#" class="btn btn-primary-dark" [routerLink]="['/company-audit/add']">Create New Audit</a>
                            </div>
                        </div>

                    </div>
                    <div class="card-body py-3">

                        <div class="grid" style="--bs-columns: 12; --bs-gap: 1rem;">
                             <div class="g-col-12 border rounded p-3">
                                <table class="table table-hover mb-0">
                                    <thead>
                                    <tr>
                                        <th *ngIf="reportSelectorCompanies?.length > 1">Company</th>
                                        <th>Name</th>
                                        <th class="d-none d-xl-table-cell">Start Date</th>
                                        <th class="d-none d-xl-table-cell">Deadline</th>
                                        <th>User</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">Rating</th>
                                        <th class="text-center">External</th>
                                        <th class="text-center">Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <ng-container *ngFor="let a of genObligationAudits;index as i">
                                    <tr>
                                        <td *ngIf="reportSelectorCompanies?.length > 1">{{a.companyName}}</td>
                                        <td>{{a.title}} <pre style="display:none;">{{a | json}}</pre></td>
                                        <td class="d-none d-xl-table-cell">{{a.startDate | date:"dd MMM yyyy"}}</td>
                                        <td [ngClass]="{'text-danger':a.deadlineDate < today && a.auditStatus == 0}">{{a.deadlineDate | date:"dd MMM yyyy"}}</td>
                                        <td class="d-none d-xl-table-cell">{{a.userName}}</td>
                                        <td class="text-center">
                                            <span class="far fa-circle text-primary" *ngIf="a.auditStatus==0" data-toggle="tooltip" title="Open"></span>
                                            <span class="fas fa-circle text-primary" *ngIf="a.auditStatus==1" data-toggle="tooltip" title="Completed"></span>
                                        </td>
                                        <td class="text-center">
                                            <ng-container *ngIf="a.auditStatus==0">
                                            </ng-container>
                                            <ng-container *ngIf="a.auditStatus==1">
                                                <span *ngIf="(a.rating / a.modulesCount) <= 0.25"><span class="fas fa-circle text-success"></span></span>
                                                <span *ngIf="(a.rating / a.modulesCount) > 0.25 && (a.rating / a.modulesCount) <= 0.75"><span class="fas fa-circle text-warning"></span></span>
                                                <span *ngIf="(a.rating / a.modulesCount) > 0.75"><span class="fas fa-circle text-danger"></span></span>
                                            </ng-container>
                                        </td>
                                        <td class="text-center">
                                            <ng-container *ngIf="a.isExternal">
                                                <i class="fas fa-check"></i>
                                            </ng-container>
                                        </td>
                                        <td class="actions text-center p-0">
                                            <a *ngIf="!a.auditStatus==1" [routerLink]="['/company-audit',a.id]" title="Launch"><i class="fas fa-rocket text-primary"></i></a>
                                            <a *ngIf="a.auditStatus==1" [routerLink]="['/company-audit',a.id]" title="View"><i class="fas fa-eye"></i></a>
                                            <button class="btn btn-link bg-transparent" data-bs-toggle="collapse" [attr.data-bs-target]="'#gbo'+i" aria-expanded="false" aria-controls="collapseExample"><span class="fas fa-caret-down"></span></button>
                                        </td>
                                    </tr>
                                    <tr id="gbo{{i}}" class="collapse">
                                        <td colspan="9" class="p-0">
                                            <table class="table table-hover light mb-0">
                                                <tbody>
                                                    <tr *ngFor="let m of a.modules; index as i">
                                                        <ng-container>
                                                            <td class="text-center">
                                                                <i class="fas fa-chevron-right"></i>
                                                            </td>
                                                            <td colspan="5">
                                                                {{m.moduleDescription}}
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="far fa-circle text-primary" *ngIf="m.moduleStatus==0" data-toggle="tooltip" title="Open"></span>
                                                                <span class="fas fa-adjust text-primary" *ngIf="m.moduleStatus==1" data-toggle="tooltip" title="In progress"></span>
                                                                <span class="fas fa-circle text-primary" *ngIf="m.moduleStatus==2" data-toggle="tooltip" title="Completed"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <ng-container *ngIf="m.moduleStatus==0">
                                                                </ng-container>
                                                                <ng-container *ngIf="m.moduleStatus==2">
                                                                    <span *ngIf="(m.weightedScore/(m.nrQuestions*2))*100 < 25"><span class="fas fa-circle text-success"></span></span>
                                                                    <span *ngIf="(m.weightedScore/(m.nrQuestions*2))*100 >= 25 && (m.weightedScore/(m.nrQuestions*2))*100 <= 75"><span class="fas fa-circle text-warning"></span></span>
                                                                    <span *ngIf="(m.weightedScore/(m.nrQuestions*2))*100 > 75"><span class="fas fa-circle text-danger"></span></span>
                                                                </ng-container>
                                                            </td>
                                                            <td class="text-center">
                                                                &nbsp;
                                                            </td>
                                                            <td class="actions text-center">
                                                                <a *ngIf="m.moduleStatus!=2" [routerLink]="['/company-audit', m.companyAuditId]" title="Launch"><i class="fas fa-rocket text-primary"></i></a>
                                                                <a *ngIf="m.moduleStatus==2" [routerLink]="['/company-audit', m.companyAuditId]" title="View"><i class="fas fa-eye text-primary"></i></a>
                                                            </td>
                                                        </ng-container>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </ng-container>

                                    </tbody>
                                </table>
                            </div>

                        </div>


                    </div>
                </div>
            </div>

            <div class="col col-12 col-lg-3 col-xl-2">

                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-between">
                        <h4 class="card-title"><i class="fa fa-fw fa-clipboard-check"></i>Audit Ratings by Month</h4>
                        <a href="#" class="float-end text-primary" data-bs-toggle="collapse" data-bs-target="#collapseCard4">
                            <i class="fa fa-chevron-down"></i>
                        </a>
                    </div>
                    <!-- Card body with a unique id and collapse class -->
                    <div id="collapseCard4" class="collapse show">
                        <div class="card-body">
                            <app-chart-rating-pm [ratingsPerMonth]="summaryRatingsPerMonth" *ngIf="showRatingsChart"></app-chart-rating-pm>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-between">
                        <h4 class="card-title"><i class="fa fa-fw fa-clipboard-check"></i>Audit Volumes by Month</h4>
                        <a href="#" class="float-end text-primary" data-bs-toggle="collapse" data-bs-target="#collapseCard5">
                            <i class="fa fa-chevron-down"></i>
                        </a>
                    </div>
                    <!-- Card body with a unique id and collapse class -->
                    <div id="collapseCard5" class="collapse show">
                        <div class="card-body">
                            <app-chart-qty-pm [quantityPerMonth]="summaryAuditsPerMonth" *ngIf="showRatingsChart"></app-chart-qty-pm>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header d-flex align-items-center justify-content-between">
                        <h4 class="card-title"><i class="fa fa-fw fa-clipboard-check"></i>Files Reviewed by Broker</h4>
                        <a href="#" class="float-end text-primary" data-bs-toggle="collapse" data-bs-target="#collapseCard6">
                            <i class="fa fa-chevron-down"></i>
                        </a>
                    </div>
                    <!-- Card body with a unique id and collapse class -->
                    <div id="collapseCard6" class="collapse show">
                        <div class="card-body">
                            <app-chart-broker-module-qty [brokerModuleQty]="summaryAuditsPerBroker" *ngIf="showRatingsChart"></app-chart-broker-module-qty>
                        </div>
                    </div>
                </div>

            </div>
        </div>

<form [formGroup]="filtersFormGroup" *ngIf="filtersFormGroup">

    <!-- // Company Filter Modal-->
    <div class="modal fade" id="companyFilterModal" tabindex="-1" aria-labelledby="companyFilterModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Filter Companies</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col">
                                <div class="row mt-3 mb-3 company-tree-group">
                                    <app-company-filter [companies]="reportSelectorCompanies" [parent]="0" [level]="0" (exportSelected)="getCompanySelected($event)" style="width:100%"></app-company-filter>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <input type="hidden" name="companyId" formControlName="companyId">
                    <input type="hidden" name="excludeDownstream" formControlName="excludeDownstream">
                    <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="updateFilters()" data-bs-dismiss="modal">Apply filter</button>
                </div>
            </div>
        </div>
    </div>

    <!-- // User Filter Modal-->
    <div class="modal fade" id="userFilterModal" tabindex="-1" aria-labelledby="userFilterModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Filter Users</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-3 col-xs-12 mb-3">
                                <div class="radio-custom radio-primary">
                                    <input type="radio" id="user-null" name="auditUserId" formControlName="auditUserId" [value]="null">
                                    <label for="user-null">
                                        All Users
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-3 col-xs-12 mb-3" *ngFor="let u of reportSelectorUsersFiltered; let i = index">
                                <div class="radio-custom radio-primary">
                                    <input type="radio" id="u-{{i}}" name="auditUserId" formControlName="auditUserId" [value]="u.companyUserId">
                                    <label for="u-{{i}}">
                                        {{u.firstName}} {{u.lastName}}<br />
                                        <span class="text-muted" *ngIf="reportSelectorCompanies?.length>1">{{u.companyName}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="updateFilters()" data-bs-dismiss="modal">Apply filter</button>
                </div>
            </div>
        </div>
    </div>

    <!-- // Date Filter Modal-->
    <div class="modal fade" id="dateFilterModal" tabindex="-1" aria-labelledby="dateFilterModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Filter Date Range</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-3">
                            </div>
                            <div class="col-md-3">
                                <h4>Start Date</h4>
                                <div appCalendar>
                                    <input id="startDate" type="hidden" formControlName="startDate" />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <h4>End Date</h4>
                                <div appCalendar>
                                    <input id="endDate" type="hidden" formControlName="endDate" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="updateFilters()" data-bs-dismiss="modal">Apply filter</button>
                </div>
            </div>
        </div>
    </div>

    <!-- // Rating Filter Modal-->
    <div class="modal fade" id="ratingFilterModal" tabindex="-1" aria-labelledby="ratingFilterModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Filter Rating</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-2 col-xs-12 mb-1"></div>
                            <div class="col-md-2 col-xs-12 mb-1">
                                <div class="radio-custom radio-primary">
                                    <input type="radio" id="ratings-all" formControlName="reportRating" [value]="null">
                                    <label for="ratings-all">
                                        All Ratings
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2 col-xs-12 mb-1">
                                <div class="radio-custom radio-primary">
                                    <input type="radio" id="ratings-positive" formControlName="reportRating" [value]="1">
                                    <label for="ratings-positive">
                                        Positive
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2 col-xs-12 mb-1">
                                <div class="radio-custom radio-primary">
                                    <input type="radio" id="ratings-ok" formControlName="reportRating" [value]="2">
                                    <label for="ratings-ok">
                                        OK
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-2 col-xs-12 mb-1">
                                <div class="radio-custom radio-primary">
                                    <input type="radio" id="ratings-high-risk" formControlName="reportRating" [value]="3">
                                    <label for="ratings-high-risk">
                                        High Risk
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-sm btn-primary" (click)="updateFilters()" data-bs-dismiss="modal">Apply filter</button>
                </div>
            </div>
        </div>
    </div>

</form>
